import { API } from '../../../../config'
import { errorHandler } from '../../auth/errorAction'

export const unmountIndexEducationLevel = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_EDUCATION_LEVEL'})
}

export const indexEducationLevel = () => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_EDUCATION_LEVEL' })
  return API.GET('/education-level/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_EDUCATION_LEVEL_SUCCESS', 
      payload: {
        data: response.data
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err.error || err.message, 
      dispatch({ type: 'LOAD_DATA_MASTER_EDUCATION_LEVEL_FAILED' }), 
    ))
  })
}